export default __webpack_public_path__ + "static/folds-5910fd5776ea7f248983893f5f83aa94.jpg";